import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@fortawesome/fontawesome-free/css/all.css'


Vue.use(Vuetify, {
    iconfont: 'fa',
    theme: {
        primary: '#22753a',
        primary_action: '#fada28',
        primary_action_green: '#23782f',
    }
})
